import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { HubspotDiscoverablePartnerProperty } from "@colab/shared";

// GET /api/settings/integrations/hubspot/partner-properties
//
// `enabled` is controlled by the dialog so the discovery call doesn't fire
// until the picker is opened.
export function useDiscoverablePartnerProperties(enabled: boolean) {
  return useQuery<
    { properties: HubspotDiscoverablePartnerProperty[] },
    ApiClientError
  >({
    queryKey: queryKeys.settings.hubspotDiscoverablePartnerProperties(),
    queryFn: () =>
      apiFetch<{ properties: HubspotDiscoverablePartnerProperty[] }>(
        "/settings/integrations/hubspot/partner-properties",
      ),
    enabled,
    staleTime: 60_000,
  });
}
